import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import Paper from 'material-ui/Paper';
import { Link } from 'react-router';
import PageLoading from '../components/PageLoading';
import AppModel from '../DataModel/AppModel';
import {List, ListItem} from 'material-ui/List';
import Subheader from 'material-ui/Subheader';

import ModeEdit from 'material-ui/svg-icons/editor/mode-edit';
import Add from 'material-ui/svg-icons/content/add';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import right_corner_style from '../utils/right-corner-style';
import * as TimeFormatter from '../utils/TimeFormatter';
import { clearUIMessage } from '../utils/UIMessageBoxes.js';

const page_bottom_white = {
  border: '25px solid white',
  backgroundColor: 'white'
};


export default
@observer class RoomsPage extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  }

  gotoNewLocationPage() {
    // Reset the new-location form.
    AppModel.newRoomForm.reset();
    this.context.router.push('/rooms/newRoom');
    clearUIMessage();
  }

  gotoLocationDetailPage(locId) {
    return function() {
      console.log("Going to location detail page for "+locId);
      this.context.router.push('/rooms/room/'+locId+'/edit');
      clearUIMessage();
    }
  }

  formatLastDisinfectedMessage(location) {
    if(!location.last_disinfected) return "";
    // Only show this for locations that are ROOMS
    if(location.id_type!='R') return "";
    return uiMsg('RM_LAST_DISINFECTED',"Last disinfected: <X>",
      TimeFormatter.dateAndTime(location.last_disinfected));
  }

  toggleLocationOpenState(location) {
    return function() {
      location.ui_open_state = !location.ui_open_state;
    }
  }

  location(loc) {
    return (
      <ListItem
        key={loc.id}
        data-locid={loc.id}
        primaryText={(<span><strong>{loc.typeName}</strong>: {loc.name}
          {loc.numberOfChildRooms>0 ? " - "+loc.numberOfChildRooms +" "+ uiMsg('RM_ROOMS') : null}
         {loc.numberOfUsers>0 ? " , "+loc.numberOfUsers+ " "+uiMsg('RM_USERS') : null}</span>)}
        secondaryText={this.formatLastDisinfectedMessage(loc)}
        initiallyOpen={loc.ui_open_state}
        onNestedListToggle={this.toggleLocationOpenState(loc)}
        onTouchTap={this.gotoLocationDetailPage(loc.id).bind(this)}
        //primaryTogglesNestedList={loc.children.length>0}
        nestedItems={loc.children.map(this.location.bind(this))}>

      </ListItem>
    )
  }

  render() {
    return (
      <PageLoading loading={AppModel.fetchingLocationData}>
        <List>
          <Subheader>{uiMsg('RM_AREAS_AND_ROOMS',"Areas and Rooms")}</Subheader>
          {AppModel.userLocations.map(this.location.bind(this))}
        </List>
        <div style={page_bottom_white}>&nbsp;</div>
        {(AppModel.canEditLocations || AppModel.canEditRooms) ?
          <FloatingActionButton style={right_corner_style}
                                children={<Add />}
                                onTouchTap={this.gotoNewLocationPage.bind(this)} />
                              : null}
      </PageLoading>
    );
  }

};



/** WEBPACK FOOTER **
 ** ./src/pages/RoomsPage.jsx
 **/